<template>
    <div class="filter-form">
        <header class="filter-form-header">
            <span>Filter {{property.filterFormLabel || property.label}}</span>
        </header>
        <div class="filter-form-body">
            <div class="checkboxes" @change="onCheckboxesChange">
                <div><label><input type="checkbox" ref="allCheckbox" checked="checked" :disabled="allCheckboxSelected">
                    Any</label></div>
                <hr>
                <template v-if="items.length">
                    <div v-for="(item,index) in items" :key="index">
                        <label :class="parameters && parameters.labelClassName">
                            <input type="checkbox" ref="optionalCheckboxes">
                            <span v-if="item.labelHTML" v-html="item.labelHTML"></span>
                            <span v-else>{{item.label}}</span>
                        </label>
                    </div>
                </template>
                <div v-else><i class="text-gray">No options available.</i></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckBoxes",
        methods: {
            focus() {

            },
            getValue() {
                if (this.allCheckboxSelected) {
                    return null;
                }
                const selectedItems = [];
                const items = this.items;
                const refOptionalCheckboxes = this.$refs.optionalCheckboxes || [];
                refOptionalCheckboxes.forEach((v, i) => {
                    if (v.checked) {
                        selectedItems.push(items[i].id);
                    }
                });
                return {selectedItems};
            },
            fillValue(payload) {
                const refAllCheckbox = this.$refs.allCheckbox;
                const refOptionalCheckboxes = this.$refs.optionalCheckboxes || [];
                const items = this.items;

                if (payload) {
                    const {selectedItems} = payload;
                    refAllCheckbox.checked = false;
                    this.allCheckboxSelected = false;
                    refOptionalCheckboxes.forEach((v, i) => {
                        v.checked = (selectedItems.indexOf(items[i].id) !== -1);
                    })
                } else {
                    refAllCheckbox.checked = true;
                    this.allCheckboxSelected = true;
                    refOptionalCheckboxes.forEach(v => {
                        v.checked = false;
                    })
                }
            },
            submit() {
                this.$emit('doSubmit', this.property.propertyKey, this.getValue());
            },
            onCheckboxesChange(event) {
                const refAllCheckbox = this.$refs.allCheckbox;
                const refOptionalCheckboxes = this.$refs.optionalCheckboxes || [];

                if (event.target.checked) {
                    if (event.target === refAllCheckbox) {
                        this.allCheckboxSelected = true;
                        refOptionalCheckboxes.forEach(v => {
                            v.checked = false;
                        })
                    } else {
                        refAllCheckbox.checked = false;
                        this.allCheckboxSelected = false;
                    }
                } else {
                    if (event.target === refAllCheckbox) {
                        throw new Error('Should not uncheck this by user:' + event.target)
                    }
                    let hasCheckedOptionalCheckbox = false;
                    for (let i = 0; i < refOptionalCheckboxes.length; i++) {
                        if (refOptionalCheckboxes[i].checked) {
                            hasCheckedOptionalCheckbox = true;
                            break;
                        }
                    }
                    if (!hasCheckedOptionalCheckbox) {
                        refAllCheckbox.checked = true;
                        this.allCheckboxSelected = true;
                    }
                }
                this.submit();
            },
        },
        data() {
            return {
                allCheckboxSelected: true,
                items: [],
            }
        },
        props: {
            property: Object,
            parameters: Object,
        },
        mounted() {
            this.items = this.parameters.items;
            let promisedItems;
            if ((promisedItems = this.parameters.promisedItems)) {
                promisedItems.then((items) => {
                    this.items = items;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .checkboxes {
        label {
            padding: 0.08rem 0;
            display: inline-flex;
            align-items: center;

            input {
                margin-right: 0.25rem;
            }
        }

        & > div {
            padding-right: 0.5rem;
        }
    }
</style>
